<template>
  <div class="time-info-container">
      <div class="weekdays">{{ airConditioningTime.weekday }}</div>
      <div class="time">{{ airConditioningTime.start }} - {{ airConditioningTime.end }}</div>
  </div>
</template>

<script>
  export default {
    props: ['airConditioningTime'],
  };
</script>
<style scoped>
  .time-info-container div {
    display: inline-block;
  }
  .weekdays {
    font-size: 12px;
    min-width: 100px;
  }
  
  .time {
    min-width: 116px;
  }
</style>
